import { FC } from "react"
import { OrderLayoutConfigForm } from "./OrderLayoutConfigForm"

interface ConfigSettingProps {}

export const ConfigSetting: FC<ConfigSettingProps> = () => {
  return <OrderLayoutConfigForm />
}
